import request from '@/utils/changanRequest'

// 查询园社联建列表
export function listZoneCommunityPosts(query) {
  return request({
    url: '/system/zoneCommunityPosts/list',
    method: 'get',
    params: query
  })
}

// 查询园社联建详细
export function getZoneCommunityPosts(id) {
  return request({
    url: '/system/zoneCommunityPosts/' + id,
    method: 'get'
  })
}

// 新增园社联建
export function addZoneCommunityPosts(data) {
  return request({
    url: '/system/zoneCommunityPosts',
    method: 'post',
    data: data
  })
}

// 修改园社联建
export function updateZoneCommunityPosts(data) {
  return request({
    url: '/system/zoneCommunityPosts',
    method: 'put',
    data: data
  })
}

// 删除园社联建
export function delZoneCommunityPosts(id) {
  return request({
    url: '/system/zoneCommunityPosts/' + id,
    method: 'delete'
  })
}

// 查询园社联建分类列表
export function listZoneCommunityPostsCategory(query) {
  return request({
    url: '/system/zoneCommunityPostsCategory/list',
    method: 'get',
    params: query
  })
}

// 查询园社联建分类详细
export function getZoneCommunityPostsCategory(id) {
  return request({
    url: '/system/zoneCommunityPostsCategory/' + id,
    method: 'get'
  })
}

// 新增园社联建分类
export function addZoneCommunityPostsCategory(data) {
  return request({
    url: '/system/zoneCommunityPostsCategory',
    method: 'post',
    data: data
  })
}

// 修改园社联建分类
export function updateZoneCommunityPostsCategory(data) {
  return request({
    url: '/system/zoneCommunityPostsCategory',
    method: 'put',
    data: data
  })
}

// 删除园社联建分类
export function delZoneCommunityPostsCategory(id) {
  return request({
    url: '/system/zoneCommunityPostsCategory/' + id,
    method: 'delete'
  })
}
